import React from "react";
import CompanyInfo from "../../data/CompanyInfo.json";

const lastUpdate = "October 2021 with effective date 8 October 2021";
const Terms = (props) => {
  return (
    <div>
      <div>
        <h1>END USER LICENSE AGREEMENT</h1>
        <h2>(Last Updated: {lastUpdate})</h2>
      </div>
      <div>
        <h2>Definitions</h2>
        <p>
          In this EULA the following definitions, when capitalized, shall have
          the following meanings:
        </p>
        <p>
          <u>Apple</u> – means Apple, Inc., any parent or group company or any
          successor thereof which operates the Apple mobile platform currently
          called “App Store”.
        </p>
        <p>
          <u>Apps</u> – means Our mobile applications and any services provided
          through the Apps. It is a part of the Services which We provide to
          You. A complete list of the Apps can be found at&nbsp;
          <a href={CompanyInfo.web} target="_blank">
            {CompanyInfo.web}
          </a>
          .
        </p>
        <p>
          <u>Company (or “{CompanyInfo.name}”, “We”, “Us”, “Our”)</u> –
          means&nbsp;
          {CompanyInfo.name} Company.
          {/* , the company registered in USA, registration
          number number, having registered office at {CompanyInfo.address} */}
        </p>
        <p>
          <u>Content</u> – means all kinds of content, including, but not
          limited to the look and feel of our Apps, information, data, text,
          reviews, articles, links, software, sound, music, photographs, graphic
          or video messages, tags or other materials uploaded, posted,
          communicated, transmitted, created, generated or otherwise made
          available or accessible via Our Services or via a Mobile Platform,
          whether publicly available or privately transmitted by a Third Party
          Supplier, or contributed, submitted, displayed or otherwise provided
          by You when using the Services, or as a result of Your interaction
          with other user of the Services.
        </p>
        <p>
          <u>Device</u> – means an authorized smartphone or a tablet or other
          mobile device, which You own or otherwise legally control solely for
          Your lawful, personal, and non-commercial use.
        </p>
        <p>
          <u>EEA</u> – means the European Economic Area.
        </p>
        <p>
          <u>EULA</u> – means this End User License Agreement, which is the
          legal agreement between You and Us, and together with all the related
          documentation sets forth the terms and conditions governing the use of
          any of Our Apps downloaded and installed by You or other related
          Services.
        </p>
        <p>
          <u>Intellectual Property Rights</u> – means, collectively, rights
          under patent, trademark, copyright, trade dress and trade secret laws,
          and any other intellectual property or proprietary rights recognized
          in any country or jurisdiction worldwide, including, without
          limitation, moral or similar rights.
        </p>
        <p>
          <u>Mobile Platform</u> – means a platform operated by a third party
          (e.g. “App Store” operated by Apple, or “Google Play” operated by
          Google), where You may access and download the Apps to Your Device.
        </p>
        <p>
          <u>Open Source Software</u> – means all or any portion of the App,
          which constitutes a nonproprietary software or software provided under
          free public license by third parties.
        </p>
        <p>
          <u>Policy</u> – means the privacy policy, which describes how We
          collect, use, process, store and share information that We collect
          about You, and which is incorporated here by this reference as a part
          of EULA.
        </p>
        <p>
          <u>Representative</u> – means a parent, or a legal guardian, or other
          representative under the applicable law of a person between 16 and 18
          years of age.
        </p>
        <p>
          <u>Services</u> – means Apps and Our related services/products and
          websites, which You download, install, use and/or visit.
        </p>
        <p>
          <u>Third Party Suppliers</u> – means third party suppliers who offer
          Content and/or services in conjunction with or through the Services.
        </p>
        <p>
          <u>Unacceptable Content</u> – means any kind of content or behavior in
          connection with the use of the Apps or Services that is either illegal
          or unacceptable under the generally accepted moral rules including,
          but not limited to the following examples:
        </p>
        <ul>
          <li>
            <p>
              engaging in or contributing to any illegal activity or activity
              that violates others’ rights;
            </p>
          </li>
          <li>
            <p>
              content that is or could be reasonably viewed as unlawful,
              harmful, harassing, defamatory, libelous, obscene or otherwise
              objectionable and unacceptable;
            </p>
          </li>
          <li>
            <p>
              providing information that is false, misleading or inaccurate;
            </p>
          </li>
          <li>
            <p>
              disclosing of any personal or proprietary information of another
              user or any other person or otherwise invading other person
              privacy;
            </p>
          </li>
          <li>
            <p>
              abuse, harassment, stalking, threats, faming or intimidation of
              any person or organization;
            </p>
          </li>
          <li>
            <p>
              profanity or use of derogatory, discriminatory, hatred or
              excessively graphic language;
            </p>
          </li>
          <li>
            <p>any content that may harm minors;</p>
          </li>
          <li>
            <p>
              disseminating or advocating in any way hate, intolerance,
              discrimination, harm, racial or ethnic hatred, violence, crime or
              war;
            </p>
          </li>
          <li>
            <p>offensive, vulgar, sexually explicit or pornographic content;</p>
          </li>
          <li>
            <p>
              promoting the use of alcohol, tobacco or any narcotic or illegal
              substances, firearms;
            </p>
          </li>
          <li>
            <p>
              transmitting software viruses, worms or any other kind of harmful
              software;
            </p>
          </li>
          <li>
            <p>
              unsolicited or unauthorized advertising, promotional materials,
              "junk mail", "spam", "chain letters", "pyramid schemes", or any
              other form of solicitation;
            </p>
          </li>
          <li>
            <p>hacking;</p>
          </li>
          <li>
            <p>
              infringing any Intellectual Property Rights, or unlawful
              provision/disclosure of information (insider information,
              confidential information, etc proprietary information);
            </p>
          </li>
          <li>
            <p>other unacceptable content or behavior.</p>
          </li>
        </ul>
        <p>
          <u>USA</u> – means the United States of America.
        </p>
        <p>
          <u>U.S. Government</u> – means, the United States of America, its
          agencies and/or instrumentalities.
        </p>
        <p>
          <u>You (or “Your” or “User”)</u> – means the person, who uses Our
          Services under this EULA and whose data is collected, stored,
          processed, used and shared according to Our Policy.
        </p>
        <p>
          <u>Your information</u> – means Your personal data and other related
          information further described in more detail in the Policy.
        </p>
        <p>
          <b>
            IMPORTANT NOTICE FOR U.S. USERS REGARDING ARBITRATION: WHEN YOU
            AGREE TO THIS EULA YOU ARE AGREEING (WITH LIMITED EXCEPTION) TO
            RESOLVE ANY DISPUTE BETWEEN YOU AND&nbsp;
            <text style={{ textTransform: "uppercase" }}>
              {CompanyInfo.name}
            </text>
            &nbsp;THROUGH BINDING, INDIVIDUAL ARBITRATION RATHER THAN IN COURT.
            PLEASE REVIEW CAREFULLY “DISPUTE RESOLUTION FOR USERS IN THE UNITED
            STATES” BELOW FOR DETAILS REGARDING ARBITRATION (INCLUDING THE
            PROCEDURE TO OPT OUT OF ARBITRATION).
          </b>
        </p>
      </div>
      <div>
        <h2>About EULA and Us</h2>
        <ul>
          <li>
            <p>
              {CompanyInfo.name} is the developer of the Apps and related
              Services, which You are about to download, install, access and/or
              use, whether on Your Device, or on Our website or any other
              platform.
            </p>
          </li>
          <li>
            <p>
              This EULA constitutes a legal agreement between You and&nbsp;
              {CompanyInfo.name}. It contains important information about Your
              rights and obligations in relation to the use of the Apps and
              related Services.
            </p>
          </li>
          <li>
            <p>
              Use of Apps and related Services is also subject to Our Policy,
              which is incorporated into this EULA by&nbsp;
              <a href={CompanyInfo.privacy}>this reference</a>
            </p>
          </li>
          <li>
            <p>
              If You download, install, access or use Our Apps or related
              Services, You hereby confirm Your consent to be bound by the terms
              and conditions of this EULA, including the Policy.&nbsp;
              <b>
                If You do not agree with any of the terms and conditions of this
                EULA, please, do not download, install, access or use the Apps
                or related Services.
              </b>
            </p>
          </li>
          <li>
            <p>
              By installing, accessing or using our Apps or related Services You
              also confirm that You are the owner of or otherwise legally use
              the Device, and that You are at least 16 years of age (or older if
              required to comply with applicable laws) and have a full legal
              capacity to enter into this agreement. In case You are between 16
              and 18 years of age, You hereby confirm, that Your Representative
              has reviewed and agrees to the terms and conditions of this EULA
              and allows You to access and/or use our Apps and related Services.
            </p>
          </li>
          <li>
            <p>
              Our Apps download/purchase page may contain certain additional
              terms, conditions and requirements, which constitute a part of
              this EULA. In case You download/purchase the Apps through the
              Mobile Platform, please, review the terms and conditions of the
              owner of that particular Mobile Platform, which may provide for
              certain additional requirements applicable to the download of the
              Apps through that Mobile Platform, its installation and use.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>License to use Our Apps and limitations</h2>
        <ul>
          <li>
            <p>
              We hereby grant You a non-exclusive, personal, limited, revocable
              and non-transferable license to access, download and use the Apps
              only on Your Devices, provided You agree to comply with all the
              terms and conditions of this EULA. This includes You complying
              with the terms and conditions in relation to Our music Apps
              copyrights, as detailed below in sections "Copyrights license -
              music Apps" and "Copyrights restrictions - Popular Songs". Please
              note that the Apps are licensed, not sold, to You. We own all
              rights, title and interest in and to the Apps and reserve all
              rights not expressly granted to You in this EULA.
            </p>
          </li>
          <li>
            <p>
              You may not sell, resell, distribute, redistribute, rent, lease,
              sublicense, assign, copy (except for a single backup copy), or in
              any other way transfer or grant any rights to the Apps to any
              third party. You may not distribute or make the Apps available
              over the network where it could be downloaded or used by multiple
              devices at the same time, except when it is expressly permitted
              under the applicable Mobile Platform terms or authorized by Us.
            </p>
          </li>
          <li>
            <p>
              You may not use any automatic or manual device or process to
              interfere with the proper working of the Apps, except to remove
              Our Apps from Your Device.
            </p>
          </li>
          <li>
            <p>
              You may not decompile, disassemble, reverse engineer or create
              derivative works of the Apps or any parts thereof. All
              modifications or enhancements to the Apps remain the sole property
              of Us.
            </p>
          </li>
          <li>
            <p>
              Notwithstanding the terms and conditions of this EULA, the Open
              Source Software is licensed to You subject to the terms and
              conditions of the respective software license agreements
              accompanying such Open Source Software.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Installation, access and using Our Services</h2>
        <ul>
          <li>
            <p>
              You are responsible for selection of the proper internet
              connection and/or paying any related charges that You may incur
              for accessing and/or using Our Services. For the exact amount of
              the charges, service plans and other conditions of the wireless or
              data connection services You shall enquire with Your mobile
              operator or Your internet service provider before You access
              and/or use Our Services. We make no representation that Our
              Services can be accessed on all wireless service plans or at any
              particular location.
            </p>
          </li>
          <li>
            <p>
              We make no representation that Our Apps can be used (including
              availability and functioning of all features) and Our Services can
              be accessed on any Device.
            </p>
          </li>
          <li>
            <p>
              You have to make sure before downloading the Apps that they are
              available in any of the languages of Your preference. We make no
              representation that the Apps are or will be available in all
              languages.
            </p>
          </li>
          <li>
            <p>
              When You purchase the Apps or related Services from a Mobile
              Platform, including subscriptions and in-app purchases, the
              payment for such purchases may be processed either by third
              parties on Our behalf, or directly by the owner of the Mobile
              Platform. When purchasing the Apps or related Services, including
              subscriptions and in-app purchases, You agree that the digital
              content will be available to You immediately, and acknowledge that
              You will lose Your rights to the 14 days cancellation period and
              refunds available for EU and EEA residents. If You download the
              Apps from a Mobile Platform owner, before effecting the purchase
              from the Mobile Platform, please also review and accept the terms
              and conditions of that Mobile Platform owner with regard to Your
              rights to cancel orders and get related refunds.
            </p>
          </li>
          <li>
            <p>
              Some of Our apps may be available on a subscription basis.
              Subscriptions may be weekly, monthly, tri-monthly, semi-annual,
              annual, or seasonal. Payments for such subscriptions would be
              charged at Your account at the confirmation of the purchase. They
              may be processed by third parties acting on Our behalf, or by the
              Mobile Platform owner. Subscription will automatically renew for
              the same price and duration period as the original subscription
              package chosen by You, unless You turn off the auto-renew: (i) in
              case of an Apple App Store, at least 24-hours before the end of
              the current subscription period, or (ii) in case of Google Play
              Store, at any time before the end of the subscription period. Your
              account will be charged for renewal within 24-hours prior to the
              end of the current subscription period (Apple), or at the end of
              the subscription period (Google) at the cost of the chosen
              package. You may manage subscriptions and turn off auto-renewal by
              going to the user's account settings after the purchase. You can
              cancel the subscription at any time and the cancellation will take
              effect after the end of the last day of that subscription period.
              Certain of Our subscription services may be offered on a free
              trial basis for a certain period of time. You may cancel a
              subscription during its free trial period via the subscription
              setting through Your account. This must be done 24 hours before
              the end of the free trial subscription period (Apple), or at any
              time before the end of the free trial subscription period
              (Google), otherwise it will be renewed as a paid subscription.
            </p>
          </li>
          <li>
            <p>
              We make no warranty or representation regarding the availability
              of Our Services at any particular time or location. There may be
              times when Our Services or any part of them are not available for
              technical or maintenance related reasons, whether on a scheduled
              or unscheduled basis.
            </p>
          </li>
          <li>
            <p>
              We have no obligation to make available to You any updates,
              supplements or subsequent versions of the Apps. We reserve the
              right to modify or discontinue any part of the Services in Our
              sole discretion with or without a prior notice. We may add or
              remove any features of functions of Our Apps. If We release a new
              version of the Apps, or make new features available, We may
              request You to update the Apps installed on your Device. Such
              updates may occur automatically or with the prior notice. In case
              of material updates, supplements or new version of Apps, We may
              also ask You to review and accept Our new EULA (applicable at that
              time) before You may install and start using the updated or new
              version of the Apps.&nbsp;
              <b>
                If You do not agree with the terms and conditions of the new
                EULA, you may not install or use the updated or new version of
                the Apps, and You shall discontinue using the Apps or any
                related Services and shall uninstall and remove the Apps from
                Your Device.
              </b>
              &nbsp; Any obligations We may have to support the previous
              versions of the Apps will be ended upon the availability of
              material updates, supplements or subsequent versions of the Apps.
            </p>
          </li>
          <li>
            <p>
              The Apps may contain specific rules, controls and guidelines,
              which can be found within the Apps themselves and which are
              related with the use of the Apps. Such rules, controls and
              guidelines form a part of this EULA and You agree that You shall
              comply with them.
            </p>
          </li>
          <li>
            <p>
              Functionality features of the Apps may contain the data location
              function, which is provided by the Third Party Supplier. This data
              location function of the Apps is provided solely for the basic
              navigational purposes that are needed for the due functioning of
              the Apps. Therefore, it is neither the intention, nor the purpose
              of the Apps to be used as any kind of navigational tool, where the
              precise location data may be needed, and You shall be solely
              responsible for any injury, damage or losses incurred due to such
              improper use of the Apps. Neither Us, nor any Third Party Supplier
              gives any guarantee as to the availability, timeliness,
              completeness, or accuracy of the location data of the Apps.
            </p>
          </li>
          <li>
            <p>
              The transmission of information over wireless and wired networks
              is not inherently secure. We use many tools to help to protect
              Your personal information against unauthorized access or
              disclosure, however, We may not guarantee that Your personal
              information or private communications will always remain private
              when using Our Apps or related Services. You accept all
              responsibility for such security risks and any damage that may
              result therefrom. It is also Your sole responsibility to use all
              reasonable and recommended measures (such as complex passwords,
              etc) in order to secure Your Device from any unauthorized access.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Privacy</h2>
        <ul>
          <li>
            <p>
              Use of the {CompanyInfo.name} Apps is subject to our&nbsp;
              <a href={CompanyInfo.privacy}>Privacy Policy</a>, which is hereby
              incorporated into this EULA by&nbsp;
              <a href={CompanyInfo.privacy}>reference</a>.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Content and user conduct</h2>
        <ul>
          <li>
            <p>
              You must comply with the laws that apply to You in the country of
              Your residence and any other location where You download and
              install Our Apps and/or access and use Our Services from. If any
              laws applicable to You restrict or prohibit You from using Our
              Services, or any part thereof (certain features, functionalities,
              etc.), You must comply with those legal restrictions.
            </p>
          </li>
          <li>
            <p>
              It is Your responsibility and obligation that all the Content You
              provide Us on accessing and/or using Our Services is and shall
              remain true, accurate and complete in all material respects and at
              all times.
            </p>
          </li>
          <li>
            <p>
              You understand and agree that all the Content that may be sent
              when using Our Services, whether publicly shared, uploaded or
              posted on third party platforms/networks or privately sent, is the
              sole responsibility of the person that sent the Content. This
              means that You, not Us, are entirely responsible for all Content
              that You may upload, communicate, transmit or otherwise make
              available. Also, it is Your obligation to ensure that such Content
              does not violate this EULA and the terms or policies of third
              party platforms/networks to which You share, upload or post the
              Content.
            </p>
          </li>
          <li>
            <p>
              It is Your responsibility and obligation not to upload,
              communicate, transmit or otherwise make available any Unacceptable
              Content. If You are concerned that someone else uploads or
              otherwise provides any Unacceptable Content, please, contact Us by
              email as follows:{" "}
              <a href={CompanyInfo.mailtoContact}>{CompanyInfo.contact}</a>.
            </p>
          </li>
          <li>
            <p>
              We do not control the Content posted via Our Services by other
              people and therefore We do not guarantee the accuracy, integrity
              or quality of that Content. You understand that when using Our
              Services, You may be exposed to Content that You may consider
              offensive, indecent or objectionable. Under no circumstances will
              We be liable in any way for any Content, including, but not
              limited to, any errors or omissions in any Content, or any losses
              or harm of any kind resulting from the use of any Content posted,
              emailed, transmitted or otherwise made available via Our Services.
            </p>
          </li>
          <li>
            <p>
              We have the right to remove any uploaded Content from Our Services
              if we reasonably decide in Our sole discretion that it constitutes
              the Unacceptable Content, or that it may bring Us or Our Services
              into disrepute. You acknowledge that We may monitor the Content
              contributed by people that use Our Services, however, We make no
              undertaking to do so.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>
          Links to Third Party Suppliers, Content and services they provide
        </h2>
        <ul>
          <li>
            <p>
              We may link or provide access to Third Party Suppliers websites or
              services from Our Services, or Our Apps may be provided in
              connection with the advertising, services and Content of Third
              Party Suppliers. We are not responsible for the availability of
              such websites or resources of the Third Party Suppliers, and We
              are not responsible or liable for any Content, advertising, or
              services they provide. Any Content, advertising or services by
              such Third Party Suppliers are provided following the terms of
              services and privacy policies to be found on the website of the
              respective Third Party Supplier and, where applicable, You must
              familiarize Yourself and accept the terms of services and privacy
              policies of such Third Party Suppliers before using their
              services. We are not responsible or liable, directly or
              indirectly, to You in relation to any losses, damages or harm
              caused by or in connection with use of any such Content or
              services by the Third Party Suppliers. Any additional charges You
              may incur in relation to the use of the services by such Third
              Party Suppliers is Your responsibility.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Intellectual property</h2>
        <ul>
          <li>
            <p>
              You acknowledge that all and any Intellectual Property Rights in
              and relating to Our Services (other than certain rights to the
              Content, which is contributed by You or other users of the
              Services), are owned by or licensed to Us, including but not
              limited to Intellectual Property Rights to all trademarks, trade
              dress, design, text, images, photographs, illustrations, audio or
              video clips, artwork, graphic material, code, content, protocols,
              software, and documentation provided to You in relation with the
              use of Our Services. Intellectual Property Rights are protected by
              the respective international, EU, US and other respective national
              copyright, trademarks, patents, trade dress and other proprietary
              rights and laws relating to Intellectual Property Rights.
            </p>
          </li>
          <li>
            <p>
              Your rights to access and use Our Services (but not any related
              object and source code) are limited strictly and solely to those
              expressly granted under the license as defined in more detail in
              section “License to use Our Apps and its limitations” above and
              subject to compliance to all provisions of this EULA. All rights
              not expressly granted hereunder are expressly reserved to Us and
              Our licensors, as the case may be.
            </p>
          </li>
          <li>
            <p>
              You further acknowledge and agree that, except to the limited
              license expressly granted to You under this EULA, You shall have
              no other rights, property or ownership interest to any of Our
              Services, including without limitation Your accounts and any data
              associated with Your accounts. You must not copy, distribute, make
              available to the public or create any derivative work from Our
              Apps or related Services or any part thereof unless We have first
              agreed to this in writing.
            </p>
          </li>
          <li>
            <p>
              You are solely responsible for any Content You contribute, upload,
              submit, display, share or otherwise provide on or through Your use
              of Our Services. It is Your obligation to ensure that such Content
              does not violate any copyright or other Intellectual Property
              Rights, and You must either own or have a license to use any such
              Content. If your Content features individuals other than You, You
              confirm that You obtained permission from such individuals or in
              case of minor children, You obtained the permission of their
              parent or legal guardian. By contributing, submitting, displaying,
              sharing or otherwise providing Your Content via Our Services You:
              (a) are representing that You are fully entitled to do so; (b)
              grant Us the non-exclusive, irrevocable, worldwide, royalty free
              license to edit, adapt, publish, reproduce, distribute, publicly
              display and use Your entry (Content) and any derivative works We
              may create from it, in any and all media (whether it exists now or
              in the future), for any purpose, in perpetuity, without any
              payment to You; (c) acknowledge that You may have what are known
              as "moral rights" in the Content, for example the right to be
              named as the creator of Your entry, etc., or any similar rights
              that may exist now or may be created in the future, and You agree
              to waive any such moral or similar rights You may have in the
              Content; (d) agree that We have no obligation to monitor or
              protect Your rights in any Content that You may submit to Us, and
              We shall not be liable for any use or disclosure of it; (e) assume
              any and all risks in relation to the use of such Content by any
              person, including any risks related to the disclosure of the
              Content (Your entry) that could make You or any third parties
              personally identifiable; (f) represent and warrant to us that such
              content does not constitute an Unacceptable Content and in other
              respects complies with the rules of section “Content and user
              conduct” as set above by this EULA.
            </p>
          </li>
          <li>
            <p>
              You are solely responsible for any Content You create or generate
              on, through or in relation to Your use of Our Services and share,
              post, upload, submit, display or otherwise provide such Content to
              Us, directly or via third party platforms (including Mobile
              Platforms)/networks (social media). It is Your obligation to
              ensure that such Content does not violate any copyright or other
              Intellectual Property Rights, and You must either own or have a
              license to use any such Content. If Your Content features
              individuals other than You, You confirm that You obtained
              permission from such individuals or in case of minor children, You
              obtained the permission of their parent or legal guardian. By
              sharing, posting, uploading, submitting, displaying or otherwise
              providing Your Content You: (a) are representing that You are
              fully entitled to do so; (b) grant Us the non-exclusive,
              revocable, transferable, sub-licensable, worldwide, royalty free
              license to edit, adapt, modify, publish, reproduce, distribute,
              publicly display and use such Content and any derivative works We
              may create from it, in any and all media (whether it exists now or
              in the future), for any purpose in relation to Our Apps or
              Services (including but not limited to marketing or promotional
              purposes such promotional material posted on social media pages
              and webpages operated by {CompanyInfo.name} and/or advertisements)
              without any payment to You (consistent with our Privacy Policy);
              (c) acknowledge that You may have what are known as "moral rights"
              in the Content, for example the right to be named as the creator
              of Your entry, etc., or any similar rights that may exist now or
              may be created in the future, and You agree to waive any such
              moral or similar rights You may have in the Content; (d) agree
              that We have no obligation to monitor or protect Your rights in
              any such Content, and you release, discharge and agree to
              hold&nbsp;{CompanyInfo.name}&nbsp;harmless from any liability in
              relation to the use or disclosure of it; (e) assume any and all
              risks in relation to the use of such Content by any person,
              including any risks related to the disclosure of the Content that
              could make You or any third parties personally identifiable; (f)
              represent and warrant to us that such content does not constitute
              an Unacceptable Content and in other respects complies with the
              rules of section “Content and user conduct” as set above by this
              EULA. This licence may be revoked and/or terminated by providing
              us with written notice of Your desire to do so by email at&nbsp;
              <a href={CompanyInfo.mailtoContact}>{CompanyInfo.contact}</a>.
            </p>
          </li>
          <li>
            <p>
              If You believe that your Intellectual Property Rights have been
              infringed by someone else over the internet, You may contact Us by
              emailing the following information to&nbsp;
              <a href={CompanyInfo.mailtoContact}>{CompanyInfo.contact}</a>: (a)
              a description of the Intellectual Property Rights and an
              explanation as to how they have been infringed; (b) a description
              of where the infringing material is located; (c) Your address and
              email address; (d) a statement by You, made under penalty of
              perjury, that (i) You have a good-faith belief that the disputed
              use of material in which You own Intellectual Property Rights is
              not authorized, and (ii) the information that You are providing is
              accurate, correct, and that You are the owner of the Intellectual
              Property Right, or authorized to act on behalf of the owner of the
              Intellectual Property Right that is allegedly infringed; and (e) a
              physical or electronic signature of the person authorized to act
              on behalf of the owner of the Intellectual Property Right that has
              allegedly been infringed.
            </p>
          </li>
          <li>
            <p>
              U.S. GOVERNMENT RESTRICTED RIGHTS: Our Services have been
              developed entirely at private expense and are provided as
              "Commercial Computer Software" or "restricted computer software".
              Any use, duplication or disclosure by the U.S. Government or a
              U.S. Government subcontractor is subject to the restrictions set
              forth in subparagraph (c)(1)(ii) of the Rights in Technical Data
              and Computer Software clauses in DFARS 252.227-7013 or as set
              forth in subparagraph (c)(1) and (2) of the Commercial Computer
              Software Restricted Rights clauses at FAR 52.227-19, as
              applicable.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Export controls and legal compliance</h2>
        <ul>
          <li>
            <p>
              Any download of Our Apps and use of Our Services shall be in
              compliance with all relevant international, U.N., USA or EU sales,
              export or import restrictions and regulations and You agree to
              comply with them. You represent and warrant that (i) You are not
              located in a country that is subject to U.S. Government embargo,
              or that has been designated by the U.S. Government as a "terrorist
              supporting" country; (ii) You are not listed on any U.S Goverment
              list of prohibited or restricted parties; and (iii) You comply
              with relevant U.N. and EU sanctions and embargoes.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Term, termination and survival</h2>
        <ul>
          <li>
            <p>
              The license under this EULA is effective for an indefinite period
              of time, until {CompanyInfo.name} terminates it, or until You
              decide to terminate it by uninstalling and discontinuing use of
              the Apps. The EULA, Your rights and licenses hereunder will
              terminate automatically without notice, if You fail to comply with
              any of the provisions of this EULA. {CompanyInfo.name} reserves
              the right to suspend, discontinue, enhance, update or otherwise
              modify the Apps (or any of its features or functionalities), or
              its availability to You, at any time without notice. Upon
              termination of the license to the Apps, You will cease all use of
              the Apps and related Services.
            </p>
          </li>
          <li>
            <p>
              All provisions of this EULA with regard to Privacy, Intellectual
              Property Rights, disclaimer of warranty, limitation of liability,
              indemnification, applicable law and severability, waivers and
              dispute resolution will survive the termination.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Disclaimer of warranty</h2>
        <ul>
          <li>
            <p>
              THE APPS AND RELATED SERVICES ARE PROVIDED ON AN “AS IS” BASIS,
              WITH ALL FAULTS AND WITHOUT A WARRANTY OF ANY KIND. YOU USE THEM
              AT YOUR SOLE RISK AND THE ENTIRE RISK AS TO SATISFACTORY QUALITY,
              PERFORMANCE, ACCURACY AND EFFORT IS WITH YOU. TO THE MAXIMUM
              EXTENT PERMITTED BY THE APPLICABLE LAW,&nbsp;
              <text style={{ textTransform: "uppercase" }}>
                {CompanyInfo.name}
              </text>
              , ON BEHALF OF ITSELF AND ANY OF ITS AFFILIATES, LICENSORS,
              DISTRIBUTORS, THIRD PARTY SUPPLIERS AND OWNERS OF THE MOBILE
              PLATFORMS, EXPRESSLY DISCLAIMS ANY AND ALL WARRANTIES, EXPRESS OR
              IMPLIED, STATUTORY OR OTHERWISE, INCLUDING, BUT NOT LIMITED TO THE
              IMPLIED WARRANTIES OF FITNESS FOR A PARTICULAR PURPOSE,
              MERCHANTABILITY, TITLE, QUALITY, ACCURACY, QUIET ENJOYMENT AND
              NON-INFRINGEMENT OF THIRD PARTY RIGHTS, AND ANY IMPLIED WARRANTIES
              ARISING FROM COURSE OF DEALING OR PERFORMANCE. WITHOUT
              LIMITATION,&nbsp;
              <text style={{ textTransform: "uppercase" }}>
                {CompanyInfo.name}
              </text>
              &nbsp; MAKES NO WARRANTY THAT THE APPS AND RELATED SERVICES AND
              THE QUALITY THEREOF WILL MEET YOUR REQUIREMENTS AND EXPECTATIONS,
              THAT THEY WILL BE UNINTERRUPTED, TIMELY, CORRECT, ERROR-FREE,
              SECURE, THAT DEFECTS WILL BE CORRECTED OR THAT THE APPS AND
              RELATED SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
              TO THE MAXIMUM EXTENT PERMITTED BY THE APPLICABLE LAW, WE ASSUME
              NO LIABILITY OR RESPONSIBILITY FOR ANY KIND OF PROPERTY DAMAGE OR
              LOSSES ARISING FROM YOUR USE OF OUR APPS OR RELATED SERVICES, OR
              DUE TO ANY UNAUTHORIZED ACCESS OR OTHER ILLEGAL ACTIONS BY ANY
              THIRD PARTY, OR DUE TO ANY ERRORS OR OMISSIONS IN ANY CONTENT,
              INCLUDING ANY DAMAGE OR LOSSES BECAUSE OF USE OF ANY CONTENT.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Limitation of liability</h2>
        <ul>
          <li>
            <p>
              UNDER NO CIRCUMSTANCES WILL&nbsp;
              <text style={{ textTransform: "uppercase" }}>
                {CompanyInfo.name}
              </text>
              &nbsp;OR ITS DIRECTORS, OFFICERS, EMPLOYEES, AGENTS,
              COMMISSIONAIRES OR LICENSORS BE LIABLE FOR ANY LOSS OR INJURY OR
              ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, RELIANCE,
              CONSEQUENTIAL, EXEMPLARY OR PUNITIVE DAMAGES, OR ANY DAMAGES
              WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR INJURY TO
              PERSON OR PROPERTY, FOR LOSS OF BUSINESS, REVENUE, PROFITS,
              GOODWILL, BUSINESS INTERRUPTION, LOSS OF BUSINESS INFORMATION,
              LOSS OF PRIVACY, FAILURE TO MEET ANY DUTY OR NEGLIGENCE) ARISING
              OUT OF OR IN ANY WAY RELATED TO THE USE OR INABILITY TO USE THE
              APPS OR RELATED SERVICES, BREACH OF CONTRACT, UNAUTHORISED ACCESS,
              TORT, INCLUDING NEGLIGENCE, OR ANY OTHER ACTION BY ANY THIRD
              PARTY, EVEN IF WE OR OUR AUTHORISED REPRESENTATIVE HAS BEEN
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT SHALL OUR
              TOTAL CUMULATIVE LIABILITY ARISING FROM THIS EULA OR RELATED TO
              YOUR USE OF THE APPS OR RELATED SERVICES, WHETHER IN CONTRACT OR
              TORT, EXCEED THE AMOUNTS ACTUALLY PAID BY YOU FOR USING THE APPS
              AND RELATED SERVICES UNDER THIS EULA DURING THE TWELVE MONTHS
              IMMEDIATELY PRECEDING THE DATE THE CLAIM FIRST AROSE. THE PARTIES
              AGREE THAT THE LIMITATIONS OF LIABILITY WILL APPLY EVEN IF ANY
              REMEDY SPECIFIED IN THIS EULA IS FOUND TO HAVE FAILED OF ITS
              ESSENTIAL PURPOSE.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Indemnification</h2>
        <ul>
          <li>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY THE APPLICABLE LAW, YOU AGREE
              TO DEFEND, INDEMNIFY AND HOLD&nbsp;
              <text style={{ textTransform: "uppercase" }}>
                {CompanyInfo.name}
              </text>
              , ITS DIRECTORS, OFFICERS, EMPLOYEES, CONSULTANTS, AGENTS,
              COMMISSIONAIRES OR LICENSORS HARMLESS FROM ANY AND ALL THIRD PARTY
              CLAIMS, SUITS, LOSSES, LIABILITY, DAMAGES COSTS AND/OR EXPENSES
              (INCLUDING, BUT NOT LIMITED TO, ATTORNEYS’ FEES) ARISING FROM YOUR
              OR INCURRED AS A RESULT OF YOUR USE OF THE APPS OR RELATED
              SERVICES, OR ANY KIND OF ALLEGED OR ACTUAL BREACH BY YOU OF THIS
              EULA, OR ANY INFRINGEMENT BY YOU OR ANY THIRD PARTY OF ANY
              INTELLECTUAL PROPERTY RIGHTS OR ANY OTHER RIGHTS OF OTHER PERSONS.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Amendments</h2>
        <ul>
          <li>
            <p>
              We can make amendments to EULA from time to time. In case of
              material amendments You will be also notified by an in-app message
              or by e-mail. Your continued use of the Apps and Services after
              the EULA has been amended shall mean that You accept the amendment
              to EULA.&nbsp;
              <b>
                If You do not agree with any amendment to this EULA, You shall
                discontinue using the Apps or any related Services and shall
                uninstall and remove the Apps from Your Device.
              </b>
              &nbsp;To uninstall and remove the Apps, please use the application
              manager provided with Your Device or consult Your Device manual
              for reference.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Applicable law and severability</h2>
        <ul>
          <li>
            <p>
              The provisions of this EULA shall be governed by and construed in
              accordance with the laws of the Ukraine.
            </p>
          </li>
          <li>
            <p>
              Depending on the laws of Your jurisdiction (place of residence),
              You may have certain rights that cannot be waived through this
              EULA and that are in addition to the terms of this EULA, and
              certain provisions of this EULA may be unenforceable as to You. To
              the extent that any term or condition of this EULA is
              unenforceable, the remainder of the EULA shall remain in full
              force and effect.
            </p>
          </li>
          <li>
            <p>
              If any part of EULA is held to be invalid or unenforceable under
              any applicable local laws or by an applicable court, that part
              shall be interpreted in a manner consistent with applicable law to
              reflect as nearly as possible Our original intentions and the
              remainder of the EULA shall remain valid and enforceable. If it is
              not possible to interpret an invalid or unenforceable part of this
              EULA in a manner consistent with applicable law, then that part
              shall be deemed deleted without affecting the remaining provisions
              of the EULA.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Waiver of Our rights</h2>
        <ul>
          <li>
            <p>
              Our failure to exercise or enforce any of Our rights under EULA
              does not waive Our right to enforce such right. Any waiver of such
              rights shall only be effective if it is in writing and signed by
              Us.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Dispute resolution</h2>
        <ul>
          <li>
            <p>
              Most concerns can be solved quickly by contacting Us at
              <a href={CompanyInfo.mailtoContact}>{CompanyInfo.contact}</a>
            </p>
          </li>
          <li>
            <p>
              In the unlikely event that We cannot solve Your concern and You
              wish to bring legal action against Us, then that dispute will be
              subject to the jurisdiction of the courts of the Ukraine, unless
              you are located in the United States and therefore section
              "Dispute Resolution for Users in the United States" below applies.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Dispute resolution for Users in the United States</h2>
        <p>
          The following terms of this section entitled "Dispute Resolution for
          Users in the United States" apply if you reside in the United States:
        </p>
        <ul>
          <li>
            <p>
              Mandatory Arbitration of Disputes. We each agree that any dispute,
              claim or controversy arising out of or relating to this EULA or
              the breach, termination, enforcement, interpretation or validity
              thereof or the use of the Services or Content (collectively,&nbsp;
              <b>“Disputes”</b>) will be resolved&nbsp;
              <b>
                solely by binding, individual arbitration and not in a class,
                representative or consolidated action or proceeding.
              </b>
              &nbsp;You and {CompanyInfo.name} agree that the U.S. Federal
              Arbitration Act governs the interpretation and enforcement of this
              EULA, and that you and {CompanyInfo.name} are each waiving the
              right to a trial by jury or to participate in a class action. This
              arbitration provision shall survive termination of this EULA.
            </p>
          </li>
          <li>
            <p>
              Exceptions and Opt-out. As limited exceptions to subsection (a)
              above: (i) you may seek to resolve a Dispute in small claims court
              If it qualifies; and (ii) we each retain the right to seek
              injunctive or other equitable relief from a court to prevent (or
              enjoin) the infringement or misappropriation of our intellectual
              property rights. In addition,&nbsp;
              <b>
                you will retain the right to opt out of arbitration entirely and
                litigate any Dispute
              </b>
              &nbsp;if you provide us with written notice of your desire to do
              so by email at&nbsp;
              <a href={CompanyInfo.mailtoContact}>{CompanyInfo.contact}</a>
              &nbsp; within thirty (30) days following the date you first agree
              to this EULA.
            </p>
          </li>
          <li>
            <p>
              Conducting Arbitration and Arbitration Rules. The arbitration will
              be conducted by the American Arbitration Association (<b>“AAA”</b>
              ) under its Consumer Arbitration Rules (the&nbsp;
              <b>“AAA Rules”</b>) then in effect, except as modified by this
              EULA. The AAA Rules are available at www.adr.org or by calling
              1-800-778-7879. A party who wishes to start arbitration must
              submit a written Demand for Arbitration to AAA and give notice to
              the other party as specified in the AAA Rules. The AAA provides a
              form Demand for Arbitration at www.adr.org. If your claim is for
              U.S. $10,000 or less, you may choose whether the arbitration will
              be conducted solely on the basis of documents submitted to the
              arbitrator, through a telephonic or video-conference hearing, or
              by an in-person hearing as established by the AAA Rules. If your
              claim exceeds U.S. $10,000, the right to a hearing will be
              determined by the AAA Rules. Any arbitration hearings will take
              place in the county (or parish) where you live, unless we both
              agree to a different location. The parties agree that the
              arbitrator shall have exclusive authority to decide all issues
              relating to the interpretation, applicability, enforceability and
              scope of this arbitration agreement.
            </p>
          </li>
          <li>
            <p>
              Arbitration Costs. Payment of all filing, administration and
              arbitrator fees will be governed by the AAA Rules. If we prevail
              in arbitration we’ll pay all of our attorneys’ fees and costs and
              won’t seek to recover them from you. If you prevail in arbitration
              you will be entitled to an award of attorneys’ fees and expenses
              to the extent provided under applicable law.
            </p>
          </li>
          <li>
            <p>
              Class Action Waiver. YOU AND&nbsp;
              <text style={{ textTransform: "uppercase" }}>
                {CompanyInfo.name}
              </text>
              &nbsp; AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN
              YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS
              MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.
              Further, if the parties’ dispute is resolved through arbitration,
              the arbitrator may not consolidate another person's claims with
              your claims, and may not otherwise preside over any form of a
              representative or class proceeding. If this specific provision is
              found to be unenforceable, then the entirety of this Dispute
              Resolution section shall be null and void.
            </p>
          </li>
          <li>
            <p>
              Severability. With the exception of any of the provisions in the
              Class Action Waiver described in subsection (e) of EULA, if an
              arbitrator or court of competent jurisdiction decides that any
              part of this EULA is invalid or unenforceable, the other parts of
              this EULA will still apply.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Notice for Apple Device users</h2>
        <ul>
          <li>
            <p>
              In case You download, install or access the Apps or related
              Services through Your Apple Device, You specifically acknowledge
              and agree that the following additional terms shall apply (in case
              of conflict between these additional terms in this section and
              other terms of this EULA the terms of this section shall prevail):
            </p>
          </li>
          <li>
            <p>
              This EULA is concluded between You and Us only, not with Apple,
              and Apple is not responsible for the Apps, related Services, or
              the content thereof;
            </p>
          </li>
          <li>
            <p>
              Apple has no obligation whatsoever to furnish any maintenance and
              support services with respect to the Apps;
            </p>
          </li>
          <li>
            <p>
              In the event of any failure of the Apps to conform to any
              applicable warranty, You may notify Apple and Apple will refund
              the purchase price for the relevant Apps to You. To the maximum
              extent permitted by applicable law, Apple has no other warranty
              obligation whatsoever with respect to the Apps and any other
              claims, losses, liabilities, damages, costs or expenses
              attributable to any failure to conform to any warranty will be Our
              sole responsibility;
            </p>
          </li>
          <li>
            <p>
              Apple is not responsible for addressing any claims by You or a
              third party relating to the Apps or Your possession and/or use of
              the Apps, including, but not limited to: (i) product liability
              claims; (ii) any claim that the Apps fail to conform to any
              applicable legal or regulatory requirement; and (iii) claims
              arising under consumer protection, privacy or similar legislation;
            </p>
          </li>
          <li>
            <p>
              To the extent We are required to provide indemnification by
              applicable law, We and not Apple, shall be solely responsible for
              the investigation, defense, settlement and discharge of any third
              party claim that the Apps or Your possession and use of the Apps
              infringes that third party‘s Intellectual Property Rights;
            </p>
          </li>
          <li>
            <p>
              Apple and its subsidiaries are third party beneficiaries of this
              EULA and upon Your acceptance of the terms and conditions of this
              EULA, Apple will have the right (and will be deemed to have
              accepted the right) to enforce this EULA against You as a third
              party beneficiary of this EULA;
            </p>
          </li>
          <li>
            <p>
              {CompanyInfo.name} authorizes the use of the Apps by multiple
              users through the Family Sharing or any similar functionality
              provided by Apple.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <h2>Queries regarding this EULA</h2>
        <ul>
          <li>
            <p>
              Should you have any questions, complaints or claims regarding the
              terms and conditions of this EULA, or any other queries, please,
              contact Us by email as follows:&nbsp;
              <a href={CompanyInfo.mailtoContact}>{CompanyInfo.contact}</a>
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Terms;
